export default {
    greetingSpacing: 24,
    // Montserrat is the MCC brand face and the one the header artwork is set in; Avenir
    // stays behind it so a failed font request degrades to what the app used to use
    // rather than to the system sans. A creditor can still override the whole stack
    // through `refi.theme.fontFamily`.
    fontFamily: '\'Montserrat\', \'Avenir\', sans-serif',
    header: {
        top: '50%'
    },
    colors: {
        background: '#ffffff',
        greeting: '#484848',
        strong: '#4a4a4a',
        subtle: '#A0A0A0',
        header: '#ffffff'
    }
};
